export default "__VITE_ASSET__DQGwMkqm__"